import { useMemo } from "react";
import { Modal } from "react-bootstrap";
import styles from '../Market.module.css';
import { OpDataGrid } from "op2mise-react-widgets";
import Button from "shared/components/button/Button";import StationNetworkTypeEnum from "enums/StationNetworkTypeEnum";

import MarketStorage from "../MarketStorage";

const StationAndCableListModal = ({    
    list,
    marketName,
    onHide,
    show,
}) => {

    const displayType = (params) => StationNetworkTypeEnum[params.value];

    const columnDefs = useMemo(() => {
      return [
        {
            field: 'code',
            headerName: 'STATION/CABLE',
            pinned: 'left',
            width: 140,
        },
        {
            field: 'alias',
            headerName: 'ALIAS',
            width: 120,
        },
        {
            field: 'network',
            headerName: 'NETWORK/PROVIDER',
            width: 120,
        },
        {
            field: 'name',
            headerName: 'OWNER',
            width: 120,
        },
        {
            field: 'networkType',
            headerName: 'TYPE',
            width: 120,
            valueFormatter: displayType,
            filterParams: {
              valueFormatter: displayType,
            },
            tooltipValueGetter: displayType,
        },
        {
            field: 'format',
            headerName: 'format',
            width: 120,
        },
        {
            field: 'frequency',
            headerName: 'frequency',
            width: 120,
        },
        {
            field: 'stationContact',
            headerName: 'contact',
            width: 120,
        },
      ];
    }, []);

    return (
        <Modal centered show={show} onHide={onHide} dialogClassName={styles.stationsAndCablesModal}>
            <div className={styles.stationWrapper}>
                <p className={styles.stationsAndCablesModalTitle}>{marketName} - Stations and Cables</p>
                    <OpDataGrid
                        columns={columnDefs}
                        customVerbiage={'No stations/cables found'}
                        defaultSort={{
                            field: 'code',
                            sort: 'asc',
                        }}
                        gridHeightPreset={{ height: '400px', minHeight: '300px'}}
                        gridName={'mp-data-management-markets-station-cables-view'}
                        lockPinned
                        resizable={true}
                        rows={list}
                        sharedColumnProperties={{
                            filter: { fields: MarketStorage.stationAndCablesHeaders, value: true },
                            sortable: { fields: MarketStorage.stationAndCablesHeaders, value: true },
                        }}
                        showAlternativeRowHighlight
                        suppressRowClickSelection={true}
                    />

                <Button
                    text={'Close'}
                    onClick={onHide}
                    style={{ float: 'right', marginTop: '30px' }}
                />
            </div>
        </Modal>
    )
};

export default StationAndCableListModal;